import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly uuid: string, readonly lang?: Types.AccountsUserLang | null, readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly uuid: string, readonly sensorExclusions: ReadonlyArray<{ readonly __typename?: 'YalperSensorExclusion', readonly sensorName: string }>, readonly graphBudgetScores: ReadonlyArray<{ readonly __typename?: 'YalperGraphBudgetScore', readonly collectedOn: string, readonly value: number }>, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly sensor: { readonly __typename?: 'YalperSensor', readonly name: string } }>, readonly graphChecks: ReadonlyArray<{ readonly __typename?: 'YalperGraphCheck', readonly old: number, readonly new: number, readonly fixed: number, readonly collectedOn: string }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      uuid
      sensorExclusions {
        sensorName
      }
      graphBudgetScores(startDate: $startDate, endDate: $endDate) {
        collectedOn
        value
      }
      lastChecks {
        sensor {
          name
        }
      }
      graphChecks(startDate: $startDate, endDate: $endDate) {
        old
        new
        fixed
        collectedOn
      }
    }
    uuid
    lang
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;